package com.exura.components

import androidx.compose.runtime.Composable
import com.exura.ui.TextStyles
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.StyleScope
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.dom.Div

@Composable
internal fun FlexContent(
    weight: Int,
    justifyContent: JustifyContent = JustifyContent.Center,
    style: StyleScope.() -> Unit = {},
    content: @Composable () -> Unit,
) {
    Div(
        attrs = {
            style {
                flex(weight)
                position(Position.Relative)
                display(DisplayStyle.Flex)
                justifyContent(justifyContent)
                style()
            }
        }
    ) {
        content()
    }
}
